import React from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import brandingConfig from '../../../../config/brandingConfig'

const Footer = () => {
  const { formatMessage } = useIntl()

  return (
    <div className='d-md-flex flex-md-row fw-semibold text-gray-500 fs-base justify-content-md-between w-100 d-flex flex-column align-items-center px-6 h-60px mt-15 mb-0 pb-0 company-page-border-footer pt-2'>
      <p className='text-gray-500 m-0'>
        ©{new Date().getFullYear()}
        {'  '}
        {formatMessage({ id: brandingConfig.brandName })}
      </p>
      <div className='d-flex gap-2 justify-content-center mt-3'>
        <p>{formatMessage({ id: 'Powered By' })}</p>
        <div className='founder-create-logo d-flex justify-content-center'>
          <img src={toAbsoluteUrl('/media/auth/founderCrateLogo.svg')} height={20} alt='Logo' />
        </div>
      </div>
      <div className='d-flex'>
        <Link to='/terms-of-use' className='me-4 text-gray-500'>
          {formatMessage({ id: 'Terms of use' })}
        </Link>

        <Link to='/privacy-policy' className='text-gray-500'>
          {formatMessage({ id: 'Privacy Policy' })}
        </Link>
      </div>
    </div>
  )
}

export default Footer
